import { SET_USER_GROUP_PROPERTY } from '../../common';
import {
    SAVE_USER_DETAILS,
    SAVE_USER_DETAILS_FAIL
} from '../actions/types';

import {SET_USER_PROPERTY, getIntegersParsedObject} from 'h-commons';

const initialState = {
    emailId: "",
    userId: "",
    userGroupId: "",
    firstName: "",
    lastName: "",
    domain: "",
    accountType: '',
    sharedLabels: {},
    sharedMailboxes: {},
    aliases: {},
    is_suspended: false,
    businessHourEnabled:false,
    availableFeatures: [],
    smUserLimit: {},
    autoresponseEnabled: false,
    sla: {},
    businesshour: {},
    deletionActivated: false,
    userProperties: {},
    usergroupProperties: {},
}
/**
 * Saves the current logged in user details
 * @param {Object} state Default empty state
 * @param {Object} action Action dispached from AC
 */
export const userDetails = (state = initialState, action)  => {
    switch (action.type) {
        case SAVE_USER_DETAILS: 
            return { ...state, ...getIntegersParsedObject(action.payload) };
        case SAVE_USER_DETAILS_FAIL:
            return state;
        case `${SET_USER_PROPERTY}_SUCCESS`:{
            const {property, value} = action.payload;
            return {
                ...state,
                userProperties: {
                    ...state.userProperties,
                    [property]: value
                }
            }
        }
        case `${SET_USER_GROUP_PROPERTY}_SUCCESS`:{
            const {property, value} = action.payload;
            return {
                ...state,
                usergroupProperties: {
                    ...state.usergroupProperties,
                    [property]: value
                }
            }
        }
        default:
            return state;
    }
}